import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom';
import { message } from 'antd'
import Layout from './layout';

class App extends Component {
  render() {
    message.config({top:"50%"});
    return (
      <Switch>
        <Route component={Layout} />
      </Switch>
    );
  }
}

export default App;
